import { Component, OnInit } from '@angular/core';
import { Roles } from 'src/app/tools/api.service'
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';

@Component({
    selector: 'app-cloud-missing',
    templateUrl: './missing.component.html',
    styleUrls: ['./missing.component.scss'],
})
export class CloudMissingComponent implements OnInit {
    role: Roles;
    Utils = Utils;
    isAnimating: boolean = false;

    constructor(private readonly headerService: HeaderService) { }

    ngOnInit() {
        this.headerService.changeCanBack(false);
        this.headerService.changeTitle("common.cloud");
        this.headerService.changeLogo("");
    }
}
